<dx-popup
    #workflowCommunityAttributionSelector
    width="45%"
    height="95%"
    [title]="'Workflow Community Attribution #' + workflowId"
    [showTitle]="true"
    [resizeEnabled]="true"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box #workflowCommunityAttribution width="100%" height="100%" direction="col">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%">
                        <dxi-item>
                            <dxo-label text="Community"></dxo-label>
                            <div *dxTemplate>
                                <app-multi-column-selector
                                    #communitySelector
                                    [name]="'Community'"
                                    [gridSource]="communityGridSource"
                                    [boxValue]="communityGridBoxValue"
                                    [valueExpr]="'communityId'"
                                    [displayExpr]="'communityName'"
                                    [columnDef]="communityColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 700 }"
                                    [navigateToCommunity]="true"
                                    [placeholder]="'Select Community...'"
                                    [showHeaderFilters]="true"
                                    (gridSelectionEvent)="onCommunitySelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item [ratio]="1">
                <div *dxTemplate class="top-padding">
                    <app-workflow-invoice-viewer
                        #invoiceViewer
                        [source]="pdfURL"
                        [loader]="false"
                    ></app-workflow-invoice-viewer>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate class="top-padding">
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onPopupClose()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Transfer to Corp Work Queue"
                                    hint="Transfer to Corp Work Queue"
                                    [icon]="iconRandom"
                                    (onClick)="onTransferToCorpWorkQueueClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="danger"
                                    text="Delete Workflow"
                                    hint="Delete Workflow"
                                    [icon]="iconDelete"
                                    (onClick)="onDeleteWorkflowClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after">
                            <div *dxTemplate>
                                <dx-button
                                    type="success"
                                    text="Save"
                                    hint="Save"
                                    [icon]="iconSave"
                                    (onClick)="onCommunitySaveClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-workflow-delete
    *ngIf="showDeleteWorkflowPopUp"
    [workflowId]="workflowId"
    (onDeleteWorkflow)="onDeleteWorkflow($event)"
    (onClose)="onDeleteWorkflowClose()"
></app-workflow-delete>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#workflowCommunityAttribution' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #workflowAttributionMessageBox></cc-message-box>
